module.exports = __webpack_public_path__ + "static/media/kolob.cef07239.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/kolob.svg
// module id = 1789
// module chunks = 0